export class ConfigurationBuilder<T> {
    protected visualization: T

    constructor(visualization: T) {
        this.visualization = visualization
    }
}